<script setup lang="ts">
import { onMounted } from 'vue';

onMounted(() => {
  setTimeout(() => {
    throw new Error('frontend sample error for Sentry/Bugsink verification');
  }, 0);
});
</script>

<template>
  <p>Throwing a sample error for Sentry/Bugsink verification...</p>
</template>
